import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { type ReactNode, type Ref, forwardRef } from "react";
import { cn } from "../../lib/utils";

export const TooltipProvider = TooltipPrimitive.Provider;
export const TooltipRoot = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export const TooltipContent = forwardRef<HTMLDivElement, TooltipPrimitive.TooltipContentProps>(
  function TooltipContent({ className, sideOffset = 6, ...props }, ref: Ref<HTMLDivElement>) {
    return (
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          ref={ref}
          sideOffset={sideOffset}
          className={cn(
            "z-50 overflow-hidden rounded-md bg-(--bg-overlay) border border-(--border-subtle) px-2 py-1 text-xs text-(--text-primary) shadow-(--elev-2)",
            "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
            className,
          )}
          {...props}
        />
      </TooltipPrimitive.Portal>
    );
  },
);

/** Convenience: a tooltipped trigger with a label as content. */
export function Tooltip({
  label,
  children,
  side = "bottom",
  delayDuration = 250,
}: {
  label: ReactNode;
  children: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  delayDuration?: number;
}) {
  return (
    <TooltipRoot delayDuration={delayDuration}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side}>{label}</TooltipContent>
    </TooltipRoot>
  );
}
